// De qué empresa es esta tienda (documento 20, decisión D46). En producción, por el subdominio
// (sanblas.delivery.sospy.org → "sanblas"). En desarrollo (localhost) con `?tienda=sanblas`, que queda recordado.
import { PATRON_SLUG, slugDeHost } from '../compartido';
import { guardar, leer } from './almacen';

const CLAVE_DESARROLLO = 'tienda:slug';

export function resolverSlug(
  ubicacion: { hostname: string; search: string },
  porDefecto: string,
  almacen: { leer: (k: string) => string | null; guardar: (k: string, v: string) => void } = {
    leer: (k) => leer<string>(k),
    guardar: (k, v) => guardar(k, v),
  },
): string {
  const delHost = slugDeHost(ubicacion.hostname);
  if (delHost) return delHost;
  const pedido = new URLSearchParams(ubicacion.search).get('tienda')?.trim().toLowerCase();
  if (pedido && PATRON_SLUG.test(pedido)) {
    almacen.guardar(CLAVE_DESARROLLO, pedido);
    return pedido;
  }
  const recordado = almacen.leer(CLAVE_DESARROLLO);
  if (recordado && PATRON_SLUG.test(recordado)) return recordado;
  return porDefecto;
}

export const SLUG: string =
  typeof location === 'undefined'
    ? 'sanblas'
    : resolverSlug(location, (import.meta.env.VITE_TIENDA_SLUG as string | undefined) || 'sanblas');

/** Clave de localStorage de esta tienda: dos tiendas abiertas en el mismo navegador no se pisan. */
export const claveLocal = (nombre: string): string => `tienda:${SLUG}:${nombre}`;
